import React, { forwardRef, useContext } from 'react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Col, Form, Input, Modal, notification, Row, Space } from 'antd'
import { EditableList } from '../../compnents/list/EditableList'
import { ReturnColumns, ReturnColumnsHead } from './columns'
import { current, unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import styles from './appllication.module.css'
import { ThemeContext } from '../../theme/ThemeContext'
import moment from 'moment'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
} from '../../models/datetime'
import { ProcurementQuery, ReturnHeadQuery, ReturnQuery } from './Query'
import { Category } from '../../models/category'
import {
  selectChainId,
  selectChainType,
  selectTenantId,
} from '../../app/applicationSlice'
import {
  getchainInventoryReceiptslist,
  getPurchaseBusinessListFn,
  getRemoveReceiptsFn,
  getReturnDeliveryFn,
  getReturnItemPageFn,
  getReturnPageFn,
} from './chainSlice'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { traceRoute } from '../../layouts/layoutSlice'
import { DateRangeFieldName, DateRangeType, getDateRange } from '../../compnents/form/DateSelect'

export const ReturnBusinessHeadRef = (props?: { activeKey?: any }) => {
  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const history = useHistory()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const dispatch = useDispatch<RootDispatch>()

  const usedStorageRef = React.useRef(false)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_' + props?.activeKey) || '{}'
  )

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState<any>({
    current: storageParams?.current ? Number(storageParams?.current) : 1,
    size: 10,
    recepitsDateStart: storageParams?.recepitsDateStart || timeHead,
    recepitsDateEnd: storageParams?.recepitsDateEnd || timeTail,
    [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
  })

  const [page, setPage] = useState<any>({ items: [], total: 0 })

  const [pageLoading, setPageLoading] = useState(false)

  const [searchVisible, setSearchVisible] = useState(false)

  const [searchParams, setSearchParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [searchPage, setSearchPage] = useState<any>({ items: [], total: 0 })

  const [pageSearchLoading, setPageSearchLoading] = useState(false)

  const [rowData, setRowData] = useState<any>({})

  useEffect(() => {
    if (params.current != 0) {
      getPageList()
    }
  }, [params])

  const getPageList = () => {
    setPageLoading(true)
    const useStorage =
      !usedStorageRef.current && Object.keys(storageParams || {}).length > 0
    const param = useStorage ? storageParams : params
    usedStorageRef.current = true
    if (useStorage) {
      setParams(param)
    }

    sessionStorage.setItem(
      location.pathname + '_' + props?.activeKey,
      JSON.stringify({ ...param })
    )
    
    dispatch(
      getReturnPageFn({
        ...param,
        category: Category.CGTHYW,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }

  return (
    <Col
      style={{
        backgroundColor: theme.pn,
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 0px)',
        overflow: 'hidden',
        padding: '10px 15px 0 15px',
      }}
    >
      <ReturnHeadQuery
        loading={pageLoading}
        activeKey={props?.activeKey}
        onValueChange={(v: any) => {
          setParams({
            ...params,
            ...v,
            current: v?.current
              ? v?.current
              : storageParams?.current
              ? storageParams?.current
              : 1,
          })
        }}
      />
      <EditableList
        style={{ flex: 1 }}
        scroll={{ x: '30rem' }}
        loading={pageLoading}
        page={{
          items: page.items,
          current: params.current,
          size: params.size,
          total: page.total,
        }}
        onRow={(r) => ({
          onDoubleClick: () => {
            history.push({
              pathname: '/chainPutList',
              state: {
                where: ['连锁业务', '门店退货业务'],
                name: '连锁业务',
                backName: tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                path:
                  tenantId == chainId
                    ? '/chainTransferOutbound'
                    : '/chainClaimBusiness',
                category: Category.ZDTHYW,
                selectId: r.id,
                detail: { ...r },
                approvedUserName: r?.approvedUserName,
              },
            })
          },
        })}
        pageSizeOptions={['10', '20', '50', '100']}
        rowKey={(m: any) => m.id}
        columns={ReturnColumnsHead(
          params.size * (params.current - 1),
          (action: any, t: any) => {
            switch (action) {
              case 'list':
                setParams({ ...params })
                break
              case 'delete':
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;是否确认删除？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    dispatch(getRemoveReceiptsFn(t.id))
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({
                          message: '删除成功',
                        })
                        setParams({ ...params })
                      })
                  },
                })
                break
              case 'search':
                setRowData(t)
                dispatch(
                  getReturnItemPageFn({
                    ...searchParams,
                    inventoryReceiptsId: t.id,
                  })
                )
                  .then(unwrapResult)
                  .then((res: any) => {
                    setSearchPage({
                      items: res.records,
                      total: res.total,
                    })
                    setSearchVisible(true)
                  })
                break
              case 'putInto':
                setRowData(t)
                if (t?.providerType == 1) {
                  dispatch(
                    getReturnItemPageFn({
                      ...searchParams,
                      inventoryReceiptsId: t.id,
                    })
                  )
                    .then(unwrapResult)
                    .then((res: any) => {
                      setSearchPage({
                        items: res.records,
                        total: res.total,
                      })
                      setSearchVisible(true)
                    })
                } else {
                  Modal.confirm({
                    centered: true,
                    title: '确认操作',
                    content: (
                      <div>
                        <ExclamationCircleFilled
                          style={{ color: '#FFAE55', fontSize: 18 }}
                        />
                        &nbsp;是否确认入库？
                      </div>
                    ),
                    okText: '确认',
                    cancelText: '取消',
                    icon: null,
                    onOk: () => {
                      dispatch(getReturnDeliveryFn(t.id))
                        .then(unwrapResult)
                        .then(() => {
                          notification.success({
                            message: '操作成功',
                          })
                          setParams({ ...params, current: 1 })
                        })
                    },
                  })
                }
            }
          },
          Category.ZDTHYW
        )}
        onChangePage={(current, size) =>
          setParams({ ...params, current, size: size || 10 })
        }
        sticky
      />

      <Modal
        title={'入库结果查询'}
        visible={searchVisible}
        centered
        width={'80%'}
        footer={null}
        destroyOnClose
        onCancel={() => {
          setSearchVisible(false)
        }}
      >
        <EditableList
          style={{ flex: 1 }}
          scroll={{ x: '30rem' }}
          loading={pageSearchLoading}
          page={{
            items: searchPage.items,
            current: searchParams.current,
            size: searchParams.size,
            total: searchPage.total,
          }}
          pageSizeOptions={['10', '20', '50', '100']}
          rowKey={(m: any) => m.id}
          columns={[
            {
              title: '药品名称',
              align: 'center',
              dataIndex: 'name',
              width: '8rem',
              ellipsis: true,
            },
            {
              title: '批次号',
              align: 'center',
              dataIndex: 'batchNo',
              width: '6rem',
              ellipsis: true,
            },
            {
              title: '生产日期',
              align: 'center',
              dataIndex: 'productDate',
              width: '8rem',
              ellipsis: true,
              render: (_, t) => {
                return t.productDate
                  ? moment(t.productDate).format(DateTimeFormatSimple)
                  : '-'
              },
            },
            {
              title: '有效期',
              align: 'center',
              dataIndex: 'deadline',
              width: '8rem',
              ellipsis: true,
              render: (_, t) => {
                return t.deadline
                  ? moment(t.deadline).format(DateTimeFormatSimple)
                  : '-'
              },
            },
            {
              title: '收货数量',
              align: 'center',
              dataIndex: 'count',
              width: '8rem',
              ellipsis: true,
            },
            {
              title: '隔离数量',
              align: 'center',
              dataIndex: 'isolationCount',
              width: '8rem',
              ellipsis: true,
            },
            {
              title: '待验数量',
              align: 'center',
              dataIndex: 'pendingVerificationCount',
              width: '8rem',
              ellipsis: true,
            },
            {
              title: '收货日期',
              align: 'center',
              dataIndex: 'upAccountTime',
              width: '8rem',
              ellipsis: true,
              render: (_, t) => {
                return t.upAccountTime
                  ? moment(t.upAccountTime).format(DateTimeFormatSimple)
                  : '-'
              },
            },
            {
              title: '收货人',
              align: 'center',
              dataIndex: 'upAccountUserName',
              width: '8rem',
              ellipsis: true,
            },
          ]}
          onChangePage={(current, size) =>
            setSearchParams({ ...searchParams, current, size: size || 10 })
          }
          sticky
        />
        {rowData?.storehouseTag == '204' && (
          <Row justify='end' style={{ marginTop: '20px' }}>
            <Space>
              <Button onClick={() => setSearchVisible(false)}>取消</Button>
              <Button
                type='primary'
                onClick={() => {
                  Modal.confirm({
                    centered: true,
                    title: '确认操作',
                    content: (
                      <div>
                        <ExclamationCircleFilled
                          style={{ color: '#FFAE55', fontSize: 18 }}
                        />
                        &nbsp;是否确认入库？
                      </div>
                    ),
                    okText: '确认',
                    cancelText: '取消',
                    icon: null,
                    onOk: () => {
                      dispatch(getReturnDeliveryFn(rowData?.id))
                        .then(unwrapResult)
                        .then(() => {
                          notification.success({
                            message: '操作成功',
                          })
                          setSearchVisible(false)
                          setParams({ ...params, current: 1 })
                        })
                    },
                  })
                }}
              >
                确认入库
              </Button>
            </Space>
          </Row>
        )}
      </Modal>
    </Col>
  )
}

export const ReturnBusinessHead = forwardRef(ReturnBusinessHeadRef)
